import React, { useContext } from 'react';
import { ApiContext } from 'Services/api-context';
import { ServiceProviderProps } from './common';
import { HelpCenterServiceContext, IHelpCenterService } from 'Services/helpCenter';

export const HelpCenterServiceProvider: React.FC<ServiceProviderProps<IHelpCenterService>> = ( props, context ) => {
  const api = useContext( ApiContext );
  const helpCenterService: IHelpCenterService = new props.useClass( api );

  return (
    <HelpCenterServiceContext.Provider value={ helpCenterService }>
      { props.children }
    </HelpCenterServiceContext.Provider>
  );
};
